import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [], 
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = state.products.find(
        (item) => item.barcode === action.payload.barcode &&
                item.selectedButtonId === action.payload.selectedButtonId
      );
      if (item) {
        item.quantity += action.payload.quantity;
      } else {
        state.products.push(action.payload);
      }
    },
    editQty: (state, action) => {
      const item = state.products.find(
        (item) => item.barcode === action.payload.barcode &&
                item.selectedButtonId === action.payload.selectedButtonId
      );
      if (item) {
        if (action.payload.operation === "+") {
          item.quantity += 1;
        } else if (action.payload.operation === "-" && item.quantity > 1) {
          item.quantity -= 1;
        }
      }
    },
    removeItem: (state, action) => {
      if (!action.payload) return;
      if (typeof action.payload === "string") {
        state.products = state.products.filter(
          (item) => item.barcode !== action.payload
        );
      } else {
        state.products = state.products.filter(
          (item) => item.barcode !== action.payload.barcode ||
                  item.selectedButtonId !== action.payload.selectedButtonId
        );
      }
    },
    resetCart: (state) => {
      state.products = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { addToCart, editQty, removeItem, resetCart } = cartSlice.actions;

export default cartSlice.reducer;
